import React from "react";
import "../ServicePage/service_com_1.css";
import { Link } from "react-router-dom";
const Timerectificationpage = () => {
  return (
    <section className="love-section">
      <div className="love-container">
        {/* Left side — Title */}
        <div className="love-left">
          <h1>
            TIME <br /> RECTIFICATION
          </h1>
        </div>

        {/* Right side — Description + Button */}
        <div className="love-right">
          <p>
             This package inculdes:
          </p>
          <ul>

            <li>Accurate Time Rectification Report (final birth time)
</li>
<li>Detailed Kundli Analysis based on the rectified chart
</li>
<li>Insights on career, relationships, health, and finance
</li>
<li>Personalized remedies and guidance aligned with your planetary placements</li>
<li>Optional WhatsApp follow-up for short clarifications</li>
          </ul>
          {/* <p>
            Bibendum tortor aliquet morbi facilisis. Ut amet etiam adipiscing
            nam enim imperdiet tempus purus porttitor. Suscipit posuere blandit
            fermentum congue.
          </p> */}

        {/* ✅ Use Link instead of <a> and pass the state */}
          <Link
            to="/Book-your-slot"
            state={{ selectedService: "timerectification" }} // 👈 service key you’ll handle below
          >
            <button className="love-btn">
              BOOK NOW
              <span className="timerectificationpage-cutted-price"> 3000 </span>
              <span className="timerectificationpage-main-offer-price-rate">2100</span>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Timerectificationpage;
